<template>
  <div style="background: #eeeeee" class="Dash pa-1">
    <v-card>
      <h3 class="white--text text--lighten-4 blue-grey darken-3">
        <v-card-title class="title">
          <v-icon large color="orange lighten-4" class>mdi-view-dashboard</v-icon>Painel de Informações
        </v-card-title>
      </h3>
      <v-row class="mt-1 ml-1 pb-0 mb-n7 mt-n3">
        <v-col></v-col>
        <!--    <v-col cols="8" class="mt-1 ml-1 mb-0 pb-0">
          <v-alert text dense color="blue-grey" icon="mdi-drama-masks" dismissible border="left">
            <h4 class="orange--text text--lighten-2">Mensagem Motivacional</h4>
            <p class="ml-n12" v-html="msg"></p>
          </v-alert>
        </v-col>
        <v-col></v-col>-->
      </v-row>
      <v-row class="pl-5 pt-2">
        <v-col cols="3">
          <v-alert text dense color="blue-grey" icon="mdi-draw" border="left" class="ma-0 pr-1">
            <h4 class="orange--text text--lighten-2">Status</h4>
            <v-list dense class="caption ml-n12 mt-n4">
              <v-list-item class="pa-1 ma-0 pb-0 mb-n5">
                <v-list-item-content>Atendimentos em Aberto</v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text class="font-weight-bold" v-text="nattAberto"></v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 pb-0 mb-n5">
                <v-list-item-content>Atendimentos Concluidos</v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text class="font-weight-bold" v-text="nattConcluido"></v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 pb-0 mb-n5">
                <v-list-item-content>Numero de Contatos na Agenda</v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text class="font-weight-bold" v-text="nContatos"></v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 pb-0 mb-n5">
                <v-list-item-content>Colaboradores Registrados</v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text class="font-weight-bold" v-text="nColaboradores"></v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>
        <!--<v-col cols="3">
          <v-alert text dense color="blue-grey" icon="mdi-history" border="left" class="ma-0 pr-1">
            <h4 class="orange--text text--lighten-2 pb-2">
              Registro de Atividades
            </h4>
            
              <v-list class="caption ma-0 pa-0 ml-n12 mt-n4" two-line>
              <v-list-item class="pa-1 ma-0 mb-n5">
                <v-list-item-content>
                  <v-list-item-title>Agenda</v-list-item-title>
                  <v-list-item-subtitle class="overline">por: VICTOR.B</v-list-item-subtitle>
                  <v-list-item-subtitle class="caption">Novo Contato : Teste - (00)0000-000</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>16:39 [04/09]</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 mb-n5">
                <v-list-item-content>
                  <v-list-item-title>HelpDesk</v-list-item-title>
                  <v-list-item-subtitle class="overline">por: VICTOR.B</v-list-item-subtitle>
                  <v-list-item-subtitle class="caption">
                    Iniciou atendimento de:
                    <strong>ABCD</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>16:39 [04/09]</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 mb-n5">
                <v-list-item-content>
                  <v-list-item-title>Agenda</v-list-item-title>
                  <v-list-item-subtitle class="overline">por: VICTOR.B</v-list-item-subtitle>
                  <v-list-item-subtitle class="caption">Novo Contato : Teste - (00)0000-000</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>16:39 [04/09]</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pa-1 ma-0 mb-n5">
                <v-list-item-content>
                  <v-list-item-title>Agenda</v-list-item-title>
                  <v-list-item-subtitle class="overline">por: VICTOR.B</v-list-item-subtitle>
                  <v-list-item-subtitle class="caption">Novo Contato : Teste - (00)0000-000</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>16:39 [04/09]</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list> 
          </v-alert>
        </v-col>!-->
        <v-col>
          <v-alert text dense color="blue-grey" icon="mdi-window-restore" border="left" class="ma-0 pr-1">
            <h4 class="orange--text text--lighten-2 pb-2">
              Atendimentos em Aberto
            </h4>
            <v-row>
              <v-col cols="5">
                <v-list class="caption ma-0 pa-0 ml-n12 mt-n4" two-line>
                  <template v-for="(att, index) in attAberto">
                    <v-list-item :key="index" class="pa-1 ma-0 pb-0 mb-n5" v-if="(index < 10)">
                      <v-list-item-content>
                        <v-list-item-title class="caption">
                          <!-- exibe o nomeAgenda em tamanho normal -->
                          <div>
                            <strong>{{ att.nomeAgenda }}</strong>
                          </div>
                          <!-- exibe o senderName em tamanho menor embaixo -->
                          <div style="font-size: 1em; display: block;">
                            <span style="font-weight: normal;">{{ att.senderName }}</span> - {{ att.tel }}
                          </div>
                        </v-list-item-title>
                        <v-list-item-subtitle class="overline">
                          Setor:
                          <template v-if="att.setor !== undefined">
                            <strong>{{ att.setor[0] }}</strong>
                          </template>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
              <v-col>
                <v-list class="caption ma-0 pa-0 ml-n12 mt-n4" two-line>
                  <template v-for="(att, index) in attAberto">
                    <v-list-item :key="index" class="pa-1 ma-0 pb-0 mb-n5" v-if="(index >= 10 && index < 20)">
                      <v-list-item-content>
                        <v-list-item-title class="caption">
                          <!-- exibe o nomeAgenda em tamanho normal -->
                          <div>
                            <strong>{{ att.nomeAgenda }}</strong>
                          </div>
                          <!-- exibe o senderName em tamanho menor embaixo -->
                          <div style="font-size: 1em; display: block;">
                            <span style="font-weight: normal;">{{ att.senderName }}</span> - {{ att.tel }}
                          </div>
                        </v-list-item-title>
                        <v-list-item-subtitle class="overline">
                          Setor:
                          <template v-if="att.setor !== undefined">
                            <strong>{{ att.setor[0] }}</strong>
                          </template>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
              <v-col>
                <v-list class="caption ma-0 pa-0 ml-n12 mt-n4" two-line>
                  <template v-for="(att, index) in attAberto">
                    <v-list-item :key="index" class="pa-1 ma-0 pb-0 mb-n5" v-if="(index >= 20 && index < 30)">
                      <v-list-item-content>
                        <v-list-item-title class="caption">
                          <!-- exibe o nomeAgenda em tamanho normal -->
                          <div>
                            <strong>{{ att.nomeAgenda }}</strong>
                          </div>
                          <!-- exibe o senderName em tamanho menor embaixo -->
                          <div style="font-size: 1em; display: block;">
                            <span style="font-weight: lighter;">{{ att.senderName }}</span> - {{ att.tel }}
                          </div>
                        </v-list-item-title>
                        <v-list-item-subtitle class="overline">
                          Setor:
                          <template v-if="att.setor !== undefined">
                            <strong>{{ att.setor[0] }}</strong>
                          </template>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <h3 class="blue-grey--text text--darken-3 pt-5">
          <v-icon medium color="orange lighten-4" class="pa-5">mdi-chart-histogram</v-icon>Estatísticas dos Atendimentos
          via WhatsApp (Helpdesk)
        </h3>
      </v-row>
      <v-row class="pl-2">
        <v-col>
          <v-row>
            <pie-chart :library="{
              title: {
                display: true,
                fontSize: 14,
                fontFamily: 'Roboto',
              },
            }" suffix="%" width="90%" title="Atendimentos por Setor" :dataset="{ borderWidth: 1 }" :donut="true"
              legend="left" :colors="[
                '#E65100',
                ['#F57C00'],
                ['#FFCC80'],
                ['#FFB74D'],
                ['#FFF3E0'],
                ['#FFE0B2'],
                ['#FFF3E0'],
              ]" :data="attSetorV"></pie-chart>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <column-chart suffix="%" :library="{
              title: {
                display: true,
                fontSize: 14,
                fontFamily: 'Roboto',
                text: 'Atendimentos por dia de Semana',
              },
            }" :dataset="{ borderWidth: 0 }" :colors="['#E65100']" width="90%" :data="attSemanaV"></column-chart>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <area-chart :library="{
              title: {
                display: true,
                fontSize: 14,
                fontFamily: 'Roboto',
                text: 'Horarios com mais Atendimentos',
              },
            }" suffix="%" :colors="['#E65100']" :dataset="{ borderWidth: 0 }" width="90%"
              :data="attHorarioV"></area-chart>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Dash",
  data() {
    return {
      attSetorV: {},
      attSemanaV: {},
      attHorarioV: {},
      nattConcluido: 0,
      nattAberto: 0,
      nContatos: 0,
      msg: "",
      nColaboradores: 0,
      attAberto: [{}],
      date: new Date().toISOString().substr(0, 10),
    };
  },
  mounted() {
    /*this.$store.dispatch("msg").then((msg) => {
      this.msg =
        '"' + msg.frase + '"' + "<br><strong>Autor:</strong> " + msg.autor;
    });*/
    this.$store.dispatch("infoUsuario").then(() => {
      this.$store.dispatch("stats").then((stats) => {
        var total = 0;
        for (let index = 1; index < stats.statsSetor.length; index++) {
          const element = stats.statsSetor[index];
          total += element.count;
        }
        this.attSetorV = {
          [stats.statsSetor[1]._id]: Math.round(
            (stats.statsSetor[1].count / total) * 100
          ),
          [stats.statsSetor[2]._id]: Math.round(
            (stats.statsSetor[2].count / total) * 100
          ),
          [stats.statsSetor[3]._id]: Math.round(
            (stats.statsSetor[3].count / total) * 100
          ),
          [stats.statsSetor[4]._id]: Math.round(
            (stats.statsSetor[4].count / total) * 100
          ),
          [stats.statsSetor[5]._id]: Math.round(
            (stats.statsSetor[5].count / total) * 100
          ),
          [stats.statsSetor[6]._id]: Math.round(
            (stats.statsSetor[6].count / total) * 100
          ),
          [stats.statsSetor[7]._id]: Math.round(
            (stats.statsSetor[7].count / total) * 100
          ),
          [stats.statsSetor[8]._id]: Math.round(
            (stats.statsSetor[8].count / total) * 100
          ),
        };
        total = 0;
        for (let index = 0; index < stats.diaSemana.length; index++) {
          const element = stats.diaSemana[index];
          total += element.count;
        }
        this.attSemanaV = {
          Seg: Math.round((stats.diaSemana[1].count / total) * 100),
          Ter: Math.round((stats.diaSemana[2].count / total) * 100),
          Qua: Math.round((stats.diaSemana[3].count / total) * 100),
          Qui: Math.round((stats.diaSemana[4].count / total) * 100),
          Sex: Math.round((stats.diaSemana[5].count / total) * 100),
        };

        total = 0;
        for (let index = 0; index < stats.Horarios.length; index++) {
          const element = stats.Horarios[index];
          total += element.count;
        }
        this.nattConcluido = total;
        this.attHorarioV = {
          "08:00": Math.round((stats.Horarios[2].count / total) * 100),
          "09:00": Math.round((stats.Horarios[3].count / total) * 100),
          "10:00": Math.round((stats.Horarios[4].count / total) * 100),
          "11:00": Math.round((stats.Horarios[5].count / total) * 100),
          "12:00": Math.round((stats.Horarios[6].count / total) * 100),
          "13:00": Math.round((stats.Horarios[7].count / total) * 100),
          "14:00": Math.round((stats.Horarios[8].count / total) * 100),
          "15:00": Math.round((stats.Horarios[9].count / total) * 100),
          "16:00": Math.round((stats.Horarios[10].count / total) * 100),
          "17:00": Math.round((stats.Horarios[11].count / total) * 100),
          "18:00": Math.round((stats.Horarios[12].count / total) * 100),
          "19:00": Math.round((stats.Horarios[13].count / total) * 100),
        };
        this.nattAberto = stats.totalAberto;
        this.nContatos = stats.nContatos;
        this.nColaboradores = stats.nCol;
        this.attAberto = stats.listaAttAberto;
        /*() this.attSetorV.push({
              f: "f",
            });
            console.log("oh fdp" + this.attSetorV);*/
      });
    });
  },
};
</script>
